import React from 'react';
import { ClockIcon, BatteryLowIcon, FrownIcon, AwardIcon, CalendarXIcon, BookOpenIcon, ArrowRightIcon, UserCheckIcon } from 'lucide-react';
const points = [{
  icon: CalendarXIcon,
  title: 'Weekend sacrificati',
  desc: 'Sei stanco di rinunciare al sabato e alla domenica per preparare verifiche e correggere bozze.'
}, {
  icon: BatteryLowIcon,
  title: 'Serate senza fine',
  desc: 'Arrivi a casa esausto e devi ancora risolvere gli esercizi per la lezione del giorno dopo.'
}, {
  icon: FrownIcon,
  title: 'Alunni "spaventati"',
  desc: 'Senti che i tuoi studenti sono bloccati dalla matematica "vecchio stile" e perdono motivazione.'
}, {
  icon: AwardIcon,
  title: 'Programmazione di livello',
  desc: 'Vuoi presentare al Dirigente una programmazione moderna, visuale e in linea con le linee guida MIUR.'
}, {
  icon: BookOpenIcon,
  title: 'Materiali sempre nuovi',
  desc: 'Cerchi schede, slide e verifiche fresche senza dover ricominciare da capo ogni anno.'
}, {
  icon: ClockIcon,
  title: 'Tempo per la didattica',
  desc: 'Vuoi smettere di "fare il compilatore di esercizi" e tornare a concentrarti sull\'insegnare.'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-213">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.08) 0%, transparent 70%)'
    }} data-id="element-214"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.06) 0%, transparent 70%)'
    }} data-id="element-215"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-216">
        <div className="text-center mb-10 sm:mb-14" data-id="element-217">
          <span className="inline-flex items-center gap-2 text-xs sm:text-sm font-bold text-primary uppercase tracking-[0.2em] mb-3 sm:mb-4 bg-primary/10 border border-primary/20 px-4 py-1.5 rounded-full" data-id="element-218">
            <UserCheckIcon className="w-4 h-4" strokeWidth={2.5} data-id="element-219" />
            Fatti riconoscere
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight leading-tight" data-id="element-220">
            Questa risorsa è per te
            <br className="hidden sm:block" data-id="element-221" />
            <span className="text-text-main" data-id="element-222"> se ti riconosci </span>
            <span className="text-primary" data-id="element-223">qui sotto</span>
          </h2>
          <p className="text-text-sec text-base sm:text-lg mt-4 max-w-2xl mx-auto leading-relaxed" data-id="element-224">
            Basta che <span className="text-text-main font-bold" data-id="element-225">uno solo</span>{' '}
            di questi punti ti rappresenti.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5" data-id="element-226">
          {points.map((point, i) => {
          const Icon = point.icon;
          return <div key={i} className="flex items-start gap-4 sm:gap-5 bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light hover:border-primary/50 hover:bg-bg-alt/80 transition-all duration-300 group relative overflow-hidden" data-id="element-227">
                <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-primary to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-228"></div>

                <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-xl bg-primary/10 border border-primary/30 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 group-hover:border-primary/50 transition-colors shadow-[0_0_15px_rgba(234,88,12,0.15)]" data-id="element-229">
                  <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-primary" strokeWidth={2.2} data-id="element-230" />
                </div>

                <div className="flex-1 min-w-0" data-id="element-231">
                  <h3 className="text-text-main font-black text-base sm:text-lg mb-1 leading-tight" data-id="element-232">
                    {point.title}
                  </h3>
                  <p className="text-text-sec text-sm sm:text-base font-medium leading-relaxed" data-id="element-233">
                    {point.desc}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="mt-10 sm:mt-14 text-center" data-id="element-234">
          <div className="inline-flex flex-col sm:flex-row items-center gap-3 sm:gap-5 bg-cta-green/10 border border-cta-green/30 rounded-2xl px-6 py-5 sm:px-8 sm:py-5 max-w-2xl" data-id="element-235">
            <p className="text-text-main text-sm sm:text-base font-bold leading-relaxed" data-id="element-236">
              <span className="text-cta-green" data-id="element-237">✓</span> Allora Matematica Pronta
              è stato pensato esattamente per te.
            </p>
            <a href="#pricing" className="text-cta-green font-bold text-sm sm:text-base flex items-center gap-1.5 hover:gap-3 transition-all whitespace-nowrap" data-id="element-238">
              Vedi il Kit
              <ArrowRightIcon className="w-4 h-4" strokeWidth={2.5} data-id="element-239" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}